exports.tabType = [
  {
    label: '任务场景',
    value: 'editor'
  },
  {
    label: '系统',
    value: 'system'
  }
]
